import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type identifier = string;

@Injectable({ providedIn: "root" })
export class EditTranslationService {
	private sourceIdentifier = "";
	private languagesMap = new Map<string, string>();
	private selectedLanguages = new BehaviorSubject<Map<identifier, string>>(this.languagesMap);

	registerSelectedLanguage(identifier: string, initialLanguageValue: string, isSource: boolean): void {
		if (this.languagesMap.get(identifier) === undefined) {
			this.languagesMap.set(identifier, initialLanguageValue);
			this.selectedLanguages.next(this.languagesMap);
		}

		if (isSource) {
			this.sourceIdentifier = identifier;
		}
	}

	updateSelectedLanguage(identifier: string, updatedLanguage: string): void {
		const currentLanguage = this.languagesMap.get(identifier);
		if (currentLanguage && currentLanguage !== updatedLanguage) {
			for (const [key, value] of this.languagesMap) {
				if (value === updatedLanguage) {
					this.languagesMap.delete(key);
				}
			}
			this.languagesMap.set(identifier, updatedLanguage);
			this.selectedLanguages.next(this.languagesMap);
		}
	}

	getSelectedLanguages(): Observable<Map<identifier, string>> {
		return this.selectedLanguages.asObservable();
	}

	getSourceLanguage(): string | undefined {
		return this.languagesMap.get(this.sourceIdentifier);
	}

	removeIdentifier(identifier: string): void {
		this.languagesMap.delete(identifier);
	}
}
